import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ToggleSwitchField = ({
  id,
  label,
  input = {},
  className,
  inputClassName,
  attributes = {},
  errorMessage = '',
  meta = {},
  showErrorOnChange = false,
  onText,
  offText
}) => {
  const { error, submitFailed, touched } = meta;
  const toggleSwitchFieldClassNames = classNames('toggle-switch', className);
  const showError = !!((error && submitFailed) || (error && showErrorOnChange && touched));

  return (
    <div className={toggleSwitchFieldClassNames}>
      <label className="switch" id={id}>
        <input
          {...input}
          className={inputClassName}
          type="checkbox"
          {...attributes}
          {...(input.value && { defaultChecked: input.value })}
        />
        <div className="slider round" />
      </label>
      <div className="margin-md-left">
        { input.value ?
          <span>{onText}</span> :
          <span>{offText}</span>
        }
      </div>
      {
        showError && (
          <p className="error text-danger text-small">
            {errorMessage || error}
          </p>
        )
      }
    </div>
  );
};

ToggleSwitchField.propTypes = {
  errorMessage: PropTypes.string,
  meta: PropTypes.object,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  input: PropTypes.object,
  attributes: PropTypes.object,
  showErrorOnChange: PropTypes.bool,
  onText: PropTypes.string,
  offText: PropTypes.string
};

export default ToggleSwitchField;
